<template>
  <!-- Modals -->
  <ui-my-emergency-plan-modal />
  <ui-my-emergency-plan-exit-modal />
  <ui-mep-warning-levels-modal />
  <ui-mep-fire-danger-ratings-modal />
  <ui-mep-higher-risk-people-modal />
  <mep-complete-view-email-modal />

  <!-- Bottom sheets -->
  <gv-bottom-sheet :bottom-sheet="bottomSheets.emergencyBottomSheet">
    <ui-emergency-bottom-sheet />
  </gv-bottom-sheet>
  <gv-bottom-sheet :bottom-sheet="bottomSheets.enableGeolocateBottomSheet">
    <ui-enable-geolocate-bottom-sheet />
  </gv-bottom-sheet>

  <slot></slot>
</template>

<script setup lang="ts">
import { useBottomSheet, useModal } from '@/common';
import * as Symbols from '@/common/constants/symbols';
import { MyEmergencyPlanModalIdentifiers } from '@/features/my-emergency-plan/presentation/utils/constants';
import { RouteNames } from '@/router/types';
import { provide } from 'vue';

const modals = {
  myEmergencyPlanModal: useModal({
    openRoutes: [{ name: RouteNames.MyEmergencyPlan }, { name: RouteNames.MyEmergencyPlanShare }],
    closeRoute: { name: RouteNames.Hazards },
  }),
  myEmergencyPlanExitModal: useModal({
    openRoutes: [{ name: RouteNames.MyEmergencyPlan, hash: MyEmergencyPlanModalIdentifiers['close'] }],
    closeRoute: { name: RouteNames.MyEmergencyPlan },
    closeRouteOverrideHashes: Object.values(MyEmergencyPlanModalIdentifiers),
  }),
  myEmergencyPlanWarningLevelsModal: useModal({
    openRoutes: [
      { name: RouteNames.MyEmergencyPlan, hash: MyEmergencyPlanModalIdentifiers['warningLevels'] },
      { name: RouteNames.MyEmergencyPlan, hash: MyEmergencyPlanModalIdentifiers['warningLevelsCompleted'] },
    ],
    closeRoute: { name: RouteNames.MyEmergencyPlan },
    closeRouteOverrideHashes: Object.values(MyEmergencyPlanModalIdentifiers),
  }),
  myEmergencyPlanFireDangerRatingsModal: useModal({
    openRoutes: [
      { name: RouteNames.MyEmergencyPlan, hash: MyEmergencyPlanModalIdentifiers['fireDangerRatings'] },
      { name: RouteNames.MyEmergencyPlan, hash: MyEmergencyPlanModalIdentifiers['fireDangerRatingsCompleted'] },
    ],
    closeRoute: { name: RouteNames.MyEmergencyPlan },
    closeRouteOverrideHashes: Object.values(MyEmergencyPlanModalIdentifiers),
  }),
  myEmergencyPlanHigherRiskPeopleModal: useModal({
    openRoutes: [{ name: RouteNames.MyEmergencyPlan, hash: MyEmergencyPlanModalIdentifiers['higherRiskPeople'] }],
    closeRoute: { name: RouteNames.MyEmergencyPlan },
    closeRouteOverrideHashes: Object.values(MyEmergencyPlanModalIdentifiers),
  }),
  myEmergencyPlanSendPlanModal: useModal(),
};

const bottomSheets = {
  emergencyBottomSheet: useBottomSheet(),
  enableGeolocateBottomSheet: useBottomSheet(),
};

// Modals
provide(Symbols.MyEmergencyPlanModal, modals?.myEmergencyPlanModal);
provide(Symbols.MyEmergencyPlanExitModal, modals?.myEmergencyPlanExitModal);
provide(Symbols.MyEmergencyPlanWarningLevelsModal, modals?.myEmergencyPlanWarningLevelsModal);
provide(Symbols.MyEmergencyPlanFireDangerRatingsModal, modals?.myEmergencyPlanFireDangerRatingsModal);
provide(Symbols.MyEmergencyPlanHigherRiskPeopleModal, modals?.myEmergencyPlanHigherRiskPeopleModal);
provide(Symbols.MyEmergencyPlanSendPlanModal, modals?.myEmergencyPlanSendPlanModal);

// Bottom sheets
provide(Symbols.EmergencyBottomSheet, bottomSheets?.emergencyBottomSheet);
provide(Symbols.EnableGeolocateBottomSheet, bottomSheets?.enableGeolocateBottomSheet);
</script>
